import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Divider } from '@material-ui/core'
import SpecificComponent from '../../../commons/SpecificComponent';








export default class OpenDownloadBilant extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'xs'}
                >
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid container>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ marginRight: 20, fontSize: 18, display: 'block', fontWeight: 600 }}>{this.dictionary.financiar.downloadTemplateBilant}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        {/* <span style={{ marginRight: 20, fontSize: 14, display: 'block' }}>{this.props.factura.localitate}</span> */}
                                    </Grid>

                                </Grid>

                                <Divider style={{ marginTop: 20 }} className="pm-divider" />
                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <select
                                                id='an'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='an'
                                                // disabled={this.state.tip_bilantDisabled !== 1 ? true : false}
                                                value={this.props.bilant.an || ''}
                                                onChange={this.props.changeBilant}
                                            // placeholder={this.dictionary.pontaje.tip_bilantCautaLucrator}
                                            // onBlur={this.props.updateAngajatData}
                                            >




                                                {this.props.years.map((s, idx) => {
                                                    return (
                                                        <option key={idx} value={s}>{s}</option>
                                                    )
                                                })}


                                            </select>
                                            <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.financiar.an}</label>
                                        </div>

                                    </Grid>


                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <select
                                                id='tip'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tip'
                                                // disabled={this.state.tip_bilantDisabled !== 1 ? true : false}
                                                value={this.props.bilant.tip || ''}
                                                onChange={this.props.changeBilant}
                                            // placeholder={this.dictionary.pontaje.tip_bilantCautaLucrator}
                                            // onBlur={this.props.updateAngajatData}
                                            >




                                                {this.props.tipuriBilant.map((s, idx) => {
                                                    return (
                                                        <option key={idx} value={s.id}>{s.nume}</option>
                                                    )
                                                })}


                                            </select>
                                            <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.financiar.tipEntitate}</label>
                                        </div>

                                    </Grid>



                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            style={{ width: '100%' }}

                                            className={'add-button-green'} onClick={() => { this.props.downloadBilant() }}  >

                                            {this.dictionary.financiar.download}
                                        </Button>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </DialogContent>

                    {/* <h2 className='pm-dialog-alert-title'>{this.props.title}</h2> */}
                    {/* <DialogActions className="pm-dialog-bottom-buttons">




                    </DialogActions> */}


                </Dialog>
            </div>
        );
    }
}